export default "__VITE_ASSET__D541SpMi__"